<div class="mapping-list">
  <div class="mapping-row" *ngFor="let field of fields">

    <select
      class="mapping-select"
      [ngModel]="maps[field.id] || ''"
      (ngModelChange)="onChange(field.id, $event)"
    >
      <option value="">— Select column —</option>
      <option *ngFor="let col of cols" [value]="col">{{ col }}</option>
    </select>

    <div class="mapping-arrow">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
        <path d="M5 12h14M12 5l7 7-7 7"/>
      </svg>
    </div>

    <div class="mapping-label">
      <div class="field-dot" style="background: var(--navy)"></div>
      {{ field.label }}
      <span class="required" *ngIf="!field.optional">*</span>
    </div>

    <div class="mapping-status" [class.ok]="isMapped(field.id)">
      <svg *ngIf="isMapped(field.id)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="14" height="14">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
    </div>

  </div>
</div>
